module.exports = __webpack_public_path__ + "img/points-active.a5e44646.png";